module.exports = __webpack_public_path__ + "img/logo.88c79e5f.svg";